/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export var LeasePaymentStatus;
(function (LeasePaymentStatus) {
    LeasePaymentStatus["CURRENT"] = "Current";
    LeasePaymentStatus["IN_COLLECTIONS"] = "In Collections";
})(LeasePaymentStatus || (LeasePaymentStatus = {}));
